import { useCallback } from 'react';
import { Slider } from 'components/Slider';
import { cx } from '@linaria/core';
import { useFormikContext } from 'formik';
import { cssHelpers } from 'styles/utils/core';
import { InputField } from 'components/ui_library/Formik';
import '@reach/slider/styles.css';
import { selectModelTypeFieldTypeInfo } from 'modules/Models/components/ModelForm/utils/utils';
import { inputStyle, formContainer, inputContainer } from 'modules/Models/components/ModelForm/styles';
import { FormikInitialValues } from 'modules/Models/components/ModelForm/utils/types';
import { FormLabel } from './FormLabel';
type RangeSliderFormElementProps = React.InputHTMLAttributes<HTMLInputElement> & {
  path: string;
};
export const RangeSliderFormElement = ({
  path,
  disabled
}: RangeSliderFormElementProps) => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const {
    fieldValueMap
  } = (values as FormikInitialValues);
  const {
    description = '',
    model_type_range_info
  } = selectModelTypeFieldTypeInfo(path, (values as FormikInitialValues));
  const rangeInfo = model_type_range_info || {
    min: 0,
    max: 100,
    step: 0.01
  };
  const min = rangeInfo?.min || 0;
  const max = rangeInfo?.max || 100;
  const step = rangeInfo?.step || 0.01;
  const onInputValChange = useCallback(eventValue => {
    setFieldValue('fieldValueMap', {
      ...fieldValueMap,
      [path]: eventValue
    });
  }, [fieldValueMap, path]);
  const onChange = (num: number): void => {
    onInputValChange(num);
  };
  const onNumberChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    onInputValChange(Number(e.target.value));
  };
  const inputValue = fieldValueMap[path] || 0;
  return <div className={formContainer}>
      <div className={inputContainer}>
        <FormLabel path={path} description={(description as string)} />
        <div className={inputStyle}>
          <Slider className={cx(cssHelpers.margin.yb[1])} min={min} max={Number(max)} step={step} value={(inputValue as number)} onChange={onChange} disabled={disabled} />
          <div>
            <InputField name="input" type="number" min={min} max={max} step={step} id={path} value={(inputValue as string)} onChange={onNumberChange} />
          </div>
        </div>
      </div>
    </div>;
};